import { createContext } from 'react';
import { ClientBankAccountsLists } from 'vopay';

export type SinglePaymentBankInfoCtx = {
  bankAccount?: ClientBankAccountsLists;
  updateBankAccount: (bankAccount?: ClientBankAccountsLists) => void;
};

const SinglePaymentBankInfoContext = createContext<SinglePaymentBankInfoCtx>({
  bankAccount: {
    ABARoutingNumber: '',
    AccountHolderName: '',
    AccountNumber: '',
    Address: '',
    BankID: '',
    BranchTransitNumber: '',
    City: '',
    ClientAccountID: '',
    ClientControlledBankAccount: '',
    ClientReferenceNumber: '',
    Currency: '',
    DateAdded: '',
    EmailAddress: '',
    FinancialInstitutionNumber: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    InstitutionName: '',
    InveriteRequestGUID: '',
    IsDefault: '',
    Phone: '',
    PlaidAccountID: '',
    'PostalCode/ZipCode': '',
    'Province/State': '',
    Token: '',
    FiservToken: '',
    IntegrationType: '',
    MxAuthorizationCode: '',
    MxProcessorToken: '',
    PlaidProcessorToken: '',
  },
  updateBankAccount: () => {},
});

export default SinglePaymentBankInfoContext;
